import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import { API_BASE } from "./config";
export default function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingUser, setEditingUser] = useState(null);
  const [searchText, setSearchText] = useState("");

  // Modal states
  const [isOpen, setIsOpen] = useState(false);
  const [scanned, setScanned] = useState(false); // untuk toggle setelah scan
  const [newUser, setNewUser] = useState({ uid: "", nama: "", departemen: "" });
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const s = io(`${API_BASE}`);
    setSocket(s);

    s.on("rfid-register", (data) => {
      console.log("UID untuk registrasi:", data.uid);
      setNewUser((prev) => ({ ...prev, uid: data.uid }));
    });

    return () => s.disconnect();
  }, []);

  const fetchUsers = () => {
    fetch(`${API_BASE}/api/users `)
      .then((res) => res.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleScanCard = () => {
    if (socket) {
      socket.emit("register_request");
      Swal.fire({
        title: "Tempelkan kartu RFID sekarang",
        text: "Klik OK setelah kartu ditempel",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        setScanned(true); 
      });
    }
  };

  // Tambah user
  const handleAdd = (e) => {
    e.preventDefault();
    fetch(`${API_BASE}/api/users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newUser),
    })
      .then((res) => res.json())
      .then(() => {
        Swal.fire("Berhasil", "User berhasil ditambahkan", "success");
        setNewUser({ uid: "", nama: "", departemen: "" });
        setIsOpen(false); // tutup modal
        setScanned(false); // reset
        fetchUsers();
      })
      .catch(() => {
        Swal.fire("Error", "Gagal menambah user", "error");
      });
  };

  // Hapus user
  const handleDelete = (id) => {
    Swal.fire({
      title: "Yakin ingin hapus user ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${API_BASE}/api/users/${id}`, { method: "DELETE" })
          .then((res) => res.json())
          .then(() => {
            fetchUsers();
            Swal.fire("Berhasil", "User dihapus", "success");
          });
      }
    });
  };

  // Simpan edit
  const handleSave = () => {
    fetch(`${API_BASE}/api/users/${editingUser.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editingUser),
    })
      .then((res) => res.json())
      .then(() => {
        setEditingUser(null);
        fetchUsers();
        Swal.fire("Berhasil", "Data user diperbarui", "success");
      });
  };

  // Filter search
  const filteredUsers = users.filter(
    (u) =>
      u.uid?.toLowerCase().includes(searchText.toLowerCase()) ||
      u.nama?.toLowerCase().includes(searchText.toLowerCase()) ||
      u.departemen?.toLowerCase().includes(searchText.toLowerCase())
  );

  // Kolom DataTable
  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      width: "70px",
    },
    // { name: "UID", selector: (row) => row.uid, sortable: true },
    // { name: "Nama", selector: (row) => row.nama, sortable: true },
    // { name: "Departemen", selector: (row) => row.departemen, sortable: true },
    {
        name: "UID",
        cell: (row) =>
          editingUser?.id === row.id ? (
            <input
              type="text"
              value={editingUser.uid}
              onChange={(e) =>
                setEditingUser({ ...editingUser, uid: e.target.value })
              }
              className="border p-1 rounded w-full"
            />
          ) : (
            row.uid
          ),
        sortable: true,
      },
      {
        name: "Nama",
        cell: (row) =>
          editingUser?.id === row.id ? (
            <input
              type="text"
              value={editingUser.nama}
              onChange={(e) =>
                setEditingUser({ ...editingUser, nama: e.target.value })
              }
              className="border p-1 rounded w-full"
            />
          ) : (
            row.nama
          ),
        sortable: true,
      },
      {
        name: "Departemen",
        cell: (row) =>
          editingUser?.id === row.id ? (
            <input
              type="text"
              value={editingUser.departemen}
              onChange={(e) =>
                setEditingUser({ ...editingUser, departemen: e.target.value })
              }
              className="border p-1 rounded w-full"
            />
          ) : (
            row.departemen
          ),
        sortable: true,
      },
    {
      name: "Aksi",
      width: "220px",
      cell: (row) =>
        editingUser?.id === row.id ? (
          <div className="space-x-2">
            <button
              onClick={handleSave}
              className="bg-green-500 text-white px-3 py-1 rounded"
            >
              Simpan
            </button>
            <button
              onClick={() => setEditingUser(null)}
              className="bg-gray-400 text-white px-3 py-1 rounded"
            >
              Batal
            </button>
          </div>
        ) : (
          <div className="space-x-2">
            <button
              onClick={() => setEditingUser(row)}
              className="bg-blue-500 text-white px-3 py-1 rounded"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(row.id)}
              className="bg-red-500 text-white px-3 py-1 rounded"
            >
              Hapus
            </button>
          </div>
        ),
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
    },
  ];

  return (
    <div className="p-2">
      <h2 className="text-2xl font-bold mb-4 text-center">Manajemen Karyawan</h2>
      <div className="flex justify-between items-center mb-4 w-full">
        {/* Search */}
        <div className="flex items-center gap-2">
            <input
            type="text"
            placeholder="🔍 UID / Nama / Departemen..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="border px-2 py-1 rounded w-64"
            />
            {searchText && (
            <button
                onClick={() => setSearchText("")}
                className="bg-gray-300 px-3 py-1 rounded"
            >
                Clear
            </button>
            )}
        </div>

        <button
  onClick={() => setIsOpen(true)}
  className="flex items-center justify-center bg-green-600 hover:bg-green-700 
  text-white w-7 h-7 rounded text-xl font-bold shadow-md transition"
>
  <span className="relative -top-0.5">+</span>
</button>

    </div>


      {/* DataTable */}
      <DataTable
        columns={columns}
        data={filteredUsers}
        progressPending={loading}
        pagination
        paginationPerPage={10}
      />

      {/* Modal Tambah User */}
{isOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="relative bg-white rounded-lg p-6 w-96 shadow-lg">
      {/* Tombol Close (pojok kanan atas) */}
      <button
        onClick={() => {
          setIsOpen(false);
          setScanned(false);
        }}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
      >
        ✕
      </button>

      <h3 className="text-lg font-bold mb-4">Tambah User</h3>

            {!scanned ? (
              <div className="text-center">
                <button
                  onClick={handleScanCard}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded"
                >
                  Scan Kartu
                </button>
                <div className="mt-2 text-sm text-gray-500">
                  Klik tombol di atas untuk mulai scan kartu
                </div>
              </div>
            ) : (
              <form onSubmit={handleAdd} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium">UID</label>
                  <input
                    type="text"
                    value={newUser.uid}
                    onChange={(e) =>
                      setNewUser({ ...newUser, uid: e.target.value })
                    }
                    className="border rounded p-2 w-full"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Nama</label>
                  <input
                    type="text"
                    value={newUser.nama}
                    onChange={(e) =>
                      setNewUser({ ...newUser, nama: e.target.value })
                    }
                    className="border rounded p-2 w-full"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Departemen</label>
                  <input
                    type="text"
                    value={newUser.departemen}
                    onChange={(e) =>
                      setNewUser({ ...newUser, departemen: e.target.value })
                    }
                    className="border rounded p-2 w-full"
                    required
                  />
                </div>
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpen(false);
                      setScanned(false);
                    }}
                    className="bg-gray-400 text-white px-4 py-2 rounded"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                  >
                    Simpan
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
